module.exports = __webpack_public_path__ + "img/icon-search.e2517c35.svg";